var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavCharts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.688 30.938H7.811V6.563A.313.313 0 007.5 6.25H5.312A.313.313 0 005 6.563v26.875c0 .171.14.312.313.312h29.375c.171 0 .312-.14.312-.313V31.25a.313.313 0 00-.313-.313zM11.25 27.813h2.188c.171 0 .312-.141.312-.313v-5.625a.313.313 0 00-.313-.313H11.25a.313.313 0 00-.313.313V27.5c0 .172.141.313.313.313zm5.938 0h2.187c.172 0 .313-.141.313-.313V15a.313.313 0 00-.313-.313h-2.188a.313.313 0 00-.312.313v12.5c0 .172.14.313.313.313zm5.937 0h2.188c.171 0 .312-.141.312-.313v-9.453a.313.313 0 00-.313-.313h-2.187a.313.313 0 00-.313.313V27.5c0 .172.141.313.313.313zm5.938 0h2.187c.172 0 .313-.141.313-.313V11.875a.313.313 0 00-.313-.313h-2.188a.313.313 0 00-.312.313V27.5c0 .172.14.313.313.313z",
    fill: "#000"
  })));
}
export default SvgNavCharts;